import { GroupResource, groupResource } from '@witkac/kartamiejska-resources';
import { Group } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł grup
 *
 * @export
 * @class GroupsModule
 * @extends {EntityModule<Group, GroupResource>}
 */
export class GroupsModule extends EntityModule<Group, GroupResource> {
  constructor() {
    super(groupResource);
  }
}

export default new GroupsModule();
